import { useEffect, useState, useCallback } from "react";
import { FolderNavigator } from "./FolderNavigator";
import { refreshTreeData, invalidateCache } from "../../services/proyectoEstructurado/proyectoEstructuracionTreeService";
import { message } from "antd";

export default function HomePage({ codigo_tarea, filtro }) {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [navigationState, setNavigationState] = useState(null);
  const [rootPath, setRootPath] = useState(null);

  const buildRutaFromCodigoTarea = (input) => {
    const codigo = input?.codigo_tarea ?? input;
    if (!codigo) return null;

    const {
      codActividad,
      codigo_tarea: codigoTarea,
      datoIndicador,
      medioV,
      medioVerificacion,
      oidIndicadoresMetas 
    } = codigo;

    const indicadorOid = datoIndicador?.oid ?? oidIndicadoresMetas;
    const mvArr = medioV ?? medioVerificacion;
    const medioOid = mvArr?.[0]?.oidMedioVerificacion;

    if (!codActividad || !codigoTarea || !indicadorOid || !medioOid) {
      console.warn("⚠️ Datos incompletos para construir la ruta", {
        codActividad,
        codigoTarea,
        indicadorOid,
        medioOid
      });
      return null;
    }

    const actividad = `actividad_${codActividad.replace('.', '')}`;
    const tarea = `tarea_${codigoTarea.replace(/\./g, '')}`;
    const indicador = `indicador_${indicadorOid}`;
    const medio = `medio_verificacion_${medioOid}`;

    return `${actividad}/${tarea}/${indicador}/${medio}/`;
  };

  const buildRutaFromFiltro = (filtro) => {
    if (!filtro) return null;

    const {
      actividad,
      tarea,
      indicador,
      medioVerificacion
    } = filtro;

    if (!actividad || !tarea || !indicador || !medioVerificacion) {
      console.warn("⚠️ Datos incompletos para construir la ruta por filtro", {
        actividad,
        tarea,
        indicador,
        medioVerificacion
      });
      return null;
    }

    const actividadRuta = `actividad_${actividad.replace('.', '')}`;
    const tareaRuta = `tarea_${tarea}`;
    const indicadorRuta = `indicador_${indicador}`;
    const medioRuta = `medio_verificacion_${medioVerificacion}`;

    return `${actividadRuta}/${tareaRuta}/${indicadorRuta}/${medioRuta}/`;
  };


  // Función para recargar datos
  const reloadData = useCallback(async () => {
  try {
    setLoading(true);

    let ruta = null;

    // 🔹 Caso: viene por filtro (POA preliminar)
    if (!codigo_tarea && filtro) {
      ruta = buildRutaFromFiltro(filtro);
    }
    // 🔹 Caso: viene por codigo_tarea normal
    else if (codigo_tarea) {
      ruta = buildRutaFromCodigoTarea(codigo_tarea);
    }

    if (!ruta) {
      message.warning("No se pudo construir la ruta del indicador");
      return;
    }

    setRootPath(ruta);

    const response = await refreshTreeData(ruta, 5);
    let newData = response.children || [];
    // ✅ SOLO filtrar si hay filtro válido
    if (filtro?.proyecto?.codigo) {
      const proyectoEncontrado = newData.find(folder =>
        folder.name.startsWith(filtro.proyecto.codigo)
      );

      if (proyectoEncontrado) {
        newData = [proyectoEncontrado];
      } else {
        console.warn("⚠️ No se encontró el proyecto en el árbol");
      }
    }

    setData(newData);

  } catch (error) {
    console.error("❌ Error al recargar datos:", error);
  } finally {
    setLoading(false);
  }
}, [filtro, codigo_tarea]);



  // Función para invalidar cache
  const invalidatePathCache = useCallback(async (folderPath) => {
    try {
      await invalidateCache(folderPath);
    } catch (error) {
      console.error('❌ Error al invalidar cache:', error);
    }
  }, []);

  useEffect(() => {
    reloadData();
  }, []);

  // ✅ NO desmontamos FolderNavigator durante el refresh.
  // La carga inicial (data vacía) sí muestra el spinner;
  // los refreshes posteriores pasan loading=true como prop
  // para que FolderNavigator lo muestre inline sin perder la navegación.
  if (loading && data.length === 0) {
    return <p>Cargando datos...</p>;
  }

  return (
    <FolderNavigator
      codigo_tarea={codigo_tarea}
      filtro={filtro}
      data={data}
      loading={loading}
      onRefresh={reloadData}
      onInvalidateCache={invalidatePathCache}
      onNavigationChange={setNavigationState}
      preservedNavigationState={navigationState}
      rootPath={rootPath}
    />
  );
}